module.exports = __webpack_public_path__ + "img/item-2-1.65ab3d6d.png";